import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { ONE_PAGE_STYLE_OPTIONS } from 'layouts/OnePagePreviewLayout/types';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { STATUS_VALUE_OPTIONS } from 'components/BusinessToolForm/constants/optionValues';
import { GANTT_ONE_SIDE_PADDING } from 'components/OnePageTemplates/common/GanttChart/constants/ganttChart';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { IGanttDurationLineProps as IProps } from './types';
import { getMMYYYYformattedDate } from '../../helpers';

import styles from './GanttDurationLine.module.scss';

export const GanttDurationLine: FC<IProps> = ({
  duration,
  monthWidth,
  differenceWithStartDate,
  dateFrom,
  dateTo,
  status,
  variant,
}) => {
  const businessPlan = useBusinessToolStore(getBusinessPlan);
  const isOutlined = variant === STYLE_VARIANTS.OUTLINED;

  const onePageVariant = businessPlan.metadata.onePageTemplateStyle;

  if (duration === 0) return null;

  return (
    <Box
      className={clsx(styles.lineWrapper, {
        [styles.outlined]: isOutlined,
        [styles.toDo]: status === STATUS_VALUE_OPTIONS.TO_DO,
        [styles.inProgress_third]:
          onePageVariant === ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE &&
          status.toLowerCase() === STATUS_VALUE_OPTIONS.IN_PROGRESS.toLowerCase(),
        [styles.inProgress_second]:
          onePageVariant === ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE &&
          status.toLowerCase() === STATUS_VALUE_OPTIONS.IN_PROGRESS.toLowerCase(),
        [styles.inProgress]:
          onePageVariant !== ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE &&
          status.toLowerCase() === STATUS_VALUE_OPTIONS.IN_PROGRESS.toLowerCase(),
        [styles.done]: status === STATUS_VALUE_OPTIONS.DONE,
      })}
      sx={{
        width: `${duration * monthWidth}px`,
        left: `${differenceWithStartDate * monthWidth + GANTT_ONE_SIDE_PADDING}px`,
      }}
    >
      {!isOutlined && (
        <Box className={styles.datesWrapper}>
          <Typography className={styles.dateText} component="p" variant="subtitle2">
            {getMMYYYYformattedDate(dateFrom)}
          </Typography>
          {duration !== 1 && (
            <Typography className={styles.dateText} component="p" variant="subtitle2">
              {getMMYYYYformattedDate(dateTo)}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
